import script from "./product_scan_modal.vue?vue&type=script&setup=true&lang=js"
export * from "./product_scan_modal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__